import React from 'react';
import type { FreddieIconProps } from '../../interfaces';

export function FreddieIcon({ className }: FreddieIconProps) {
  return (
    <img
      className={className}
      src="https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/logos/logo-freddie.svg"
    />
  );
}
